export const formFieldNames = {
  serverName: 'serverName',
  template: 'template',
  memory: 'memory',
  cpu: 'cpu',
  diskSize: 'diskSize'
} as const;
